import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Welcome from "./components/welcome";
import Register from "./components/register";
import UserInformation from "./components/userInformation";
import 'bootstrap/dist/css/bootstrap.min.css'
import Device from "./components/device";
import Scan from "./components/scan"
import GetStarted from './components/get-started';
import GetNotification from './components/get-started-notification';
import Homepage from './components/homepage-mid-month';
import DeviceRegistration from './components/device-registration';
import HowToUsePage from './components/howToUse-page';
import CommunityPage from './components/communityPage';
import RewardsPage from './components/rewardsPage';
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="welcome" element={<Welcome />} />
        <Route path="register" element={<Register />} />
        <Route path="userInformation" element={<UserInformation />} />
        <Route path="device" element={<Device />} />
        <Route path="scan" element={<Scan />} />
        <Route path="get-started" element={<GetStarted />} />
        <Route path="get-started-notification" element={<GetNotification />} />
        <Route path="homepage" element={<Homepage />} />
        <Route path="device-registration" element={<DeviceRegistration />} />
        <Route path="how-to-use-page" element={<HowToUsePage />} />
        <Route path="communityPage" element={<CommunityPage />} />
        <Route path="rewardsPage" element={<RewardsPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
